import React, { useState } from "react";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import PlantForm from "../../forms/plant/PlantForm";
import EklokForm from "../../forms/eklok/EklokForm";
import ActiveEklokForm from "../../forms/eklok/ActiveEklokForm";
import CreateEklokContainer from "../../containers/ekloks/CreateEklokContainer";
import CreatePlantContainer from "../../containers/plants/CreatePlantContainer";
import ActiveEklokContainer from "../../containers/ekloks/ActiveEklokContainer";
import Modal from "../../components/Modal";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTranslation } from "react-i18next";

const Create = ({
  handleClose,
  open,
  step = 0,
  plantDefault = null,
  eklokDefault = null,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const { t } = useTranslation();

  const [activeStep, setActiveStep] = useState(step);
  const steps = [
    t("create_plant_modal.step_create_plant"),
    t("create_plant_modal.step_create_eklok"),
    t("create_plant_modal.step_gen_active_key"),
  ];
  const [plant, setPlant] = useState(plantDefault);
  const [eklok, setEklok] = useState(eklokDefault);
  const [activationCode, setActivationCode] = useState(null);

  const setNewPlant = (data) => {
    setPlant(data);
    setActiveStep(1);
  };

  const setNewEklok = (data) => {
    setEklok(data);
    setActiveStep(2);
  };

  const onClose = () => {
    setActiveStep(0);
    handleClose();
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <CreatePlantContainer setResult={setNewPlant}>
            {({ onSubmit, initialValues }) => (
              <PlantForm onSubmit={onSubmit} initialValues={initialValues} />
            )}
          </CreatePlantContainer>
        );
      case 1:
        return (
          <CreateEklokContainer setResult={setNewEklok}>
            {({ onSubmit, initialValues }) => (
              <EklokForm
                onSubmit={onSubmit}
                initialValues={{ ...initialValues, plant: plant.id }}
              />
            )}
          </CreateEklokContainer>
        );
      case 2:
        return (
          <ActiveEklokContainer setResult={setActivationCode}>
            {({ onSubmit }) => (
              <ActiveEklokForm
                onSubmit={onSubmit}
                initialValues={{ eklok: eklok.id }}
                activationCode={activationCode}
              />
            )}
          </ActiveEklokContainer>
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={() => onClose()}
      title={t("create_plant_modal.title")}
    >
      <Stepper activeStep={activeStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {getStepContent(activeStep)}
    </Modal>
  );
};

export default Create;
